// ======================================================================
// FILE:
// src/modules/finance/services/balanceSheetService.js
//
// MODULE:
// Finance & Accounts Management System (FBAMS)
//
// FEATURE:
// Balance Sheet
//
// PURPOSE:
// Frontend API client for Balance Sheet report.
//
// IMPORTANT:
// - API calls only
// - No React code
// - No UI logic
// - No navigation
// ======================================================================

import axiosClient from "../../../api/axiosClient";

// ======================================================================
// BASE URL
// ======================================================================

const BASE_URL =
    "/api/finance/balance-sheet";

// ======================================================================
// GET BALANCE SHEET
// ======================================================================

async function getBalanceSheet(
    params = {}
) {

    const response =
        await axiosClient.get(
            BASE_URL,
            {
                params,
            }
        );

    return response.data.data;
}

// ======================================================================
// EXPORT
// ======================================================================

const balanceSheetService = {

    getBalanceSheet,

};

export default balanceSheetService;